/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, Dec 60 2022, 10:39:58 am
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import { useMemo } from "react"
import { useAtom } from "jotai"
import useAuthRepo from "services/repo/useAuthRepo"
import { ComponentAtom } from "store/component/componentatom"
import { currentBankChannelAtom, currentProfileAtom, currentRoleAtom, currentRoleSettingAtom, currentUserAtom } from "store/currentUser/currentUserAtom"
import Constant from "utils/Constants"
import LocalStorageUtils from "utils/LocalStorage"

const useCurrentProfileFromTokenHooks = (showError = true) => {
    const { isLoading, checkToken, checkTokenNoErrorShown } = useAuthRepo()
    const [currentProfile, setCurrentProfile] = useAtom(currentProfileAtom)
    const [currentRoleSetting, setCurrentRoleSetting] = useAtom(currentRoleSettingAtom)
    const [currentRole, setCurrentRole] = useAtom(currentRoleAtom)
    const [currentBankChannel, setCurrentBankChannel] = useAtom(currentBankChannelAtom)
    const [currentUser, setCurrentUser] = useAtom(currentUserAtom)
    const [componentAtom, setComponentAtom] = useAtom(ComponentAtom)

    const checkGuardRole = async () => {

        try {
            let response
            if (showError) response = await checkToken()
            else response = await checkTokenNoErrorShown()
            if (response?.isSuccess) {

                LocalStorageUtils.jwtToken.set(response?.data?.token)

                setCurrentRole(response?.data?.lstRoleDto)
                setCurrentProfile(response?.data?.lstProfileTypeDto)
                setCurrentRoleSetting(response?.data?.lstLunaSettingDto)
                setComponentAtom((prev) => ({
                    ...prev,
                    isLogoutButtonShown: !(response?.data?.isButtonHideLogout),
                    userId: response?.data?.userId,
                    profileTypeId: response?.data?.profileTypeId
                }))
                setCurrentUser({lstUserDto: response?.data?.lstUserDto, lstLunaTrainerDto: response?.data?.lstLunaTrainerDto})
                setCurrentBankChannel(response?.data?.lstBankChannelDto)
                return {
                    currentRole: response?.data?.lstRoleDto,
                    currentRoleSetting: response?.data?.lstLunaSettingDto,
                    currentProfile: response?.data?.lstProfileTypeDto,
                }
    
            }

            throw response

        } catch(error) {
            throw error
        }


    }

    const refreshPrivilege = async () => {
        return checkGuardRole()
    }

    // const checkRole = {
    //     isSuperAdmin: () => currentRole?.name?.toLowerCase() === Constant.role.SUPERADMIN.toLowerCase(),
    //     // isSuperAdmin: () => true,
    //     isAdmin: () => currentRole?.name?.toLowerCase() === Constant.role.SUPERADMIN.toLowerCase(),
    //     isAdminBC: () => currentRole?.name?.toLowerCase() === Constant.role.ADMINBC.toLowerCase(),
    //     isTrainer: () => currentRole?.name?.toLowerCase() === Constant.role.TRAINER.toLowerCase(),
    //     isTrainee: () => currentRole?.name?.toLowerCase() === Constant.role.TRAINEE.toLowerCase(),
    // }

    const checkRole = useMemo(() => ({
        isSuperAdmin: () => currentRoleSetting?.keySetting === Constant.roleSetting.SUPERADMIN,
        isAdmin: () => currentRoleSetting?.keySetting === Constant.roleSetting.ADMIN,
        // isAdminBC: () => currentRoleSetting?.keySetting === Constant.roleSetting.ADMINBC,
        isAdminBC: () => currentRole?.name?.toLowerCase() === Constant.role.ADMINBC.toLowerCase(),
        isTrainer: () => currentRoleSetting?.keySetting === Constant.roleSetting.TRAINER,
        isTrainee: () => currentRoleSetting?.keySetting === Constant.roleSetting.TRAINEE,
    }), [currentRoleSetting, currentRole])

    const checkProfile = useMemo(() => ({
        isBC: () => currentProfile?.name?.toLowerCase() === Constant.profileType.BC.toLowerCase(),
        isDMTM: () => currentProfile?.name?.toLowerCase() === Constant.profileType.DMTM.toLowerCase(),
        isAgency: () => currentProfile?.name?.toLowerCase() === Constant.profileType.AGENT.toLowerCase(),
        isRealAgency: () => currentProfile?.name?.toLowerCase() === Constant.profileType.AGENCY.toLowerCase(),        
        isMRI: () => currentProfile?.name?.toLowerCase() === Constant.profileType.MRI.toLowerCase(),
        isEmployee: () => currentProfile?.name?.toLowerCase() === Constant.profileType.EMPLOYEE.toLowerCase(),
        isCorporate: () => currentProfile?.name?.toLowerCase() === Constant.profileType.CORPORATE.toLowerCase(),
    }), [currentProfile])

    const isBCFieldEnabled = (profileTypeName) => {
        if (checkProfile.isBC()) return true
        return profileTypeName?.toLowerCase() === Constant.profileType.BC.toLowerCase()
    }

    const resetAllState = () => {
        setCurrentRole(null)
        setCurrentProfile(null)
        setCurrentRoleSetting(null)
        setCurrentUser({})
    }

    return {
        isLoading,
        currentRole,
        currentProfile,
        checkRole,
        checkProfile,
        refreshPrivilege,
        isBCFieldEnabled,
        resetAllState,
        currentUser,
        currentBankChannel,
    }
}

export default useCurrentProfileFromTokenHooks
